import KeyValue from "./keyValue";

export default interface AttachmentType {
  id: number;
  name?: string;
  copyJobType?: KeyValue;
  copyJobTypeStatus?: KeyValue;
  attachmentCopyType?: KeyValue;
}

export enum AttachmentCopyTypes {
  Selection = 1,
  CreationMonth,
  CreatorYear,
}
